// Save data (you can later replace with API)
import axios from "axios";

const API_URL = "https://sms.brightechsoftware.com/api/v1/sms-input";



export const getAllSms = async () => {
    const res = await axios.get(API_URL);
    return res.data;
};

export const getActiveSms = async () => {
    const res = await axios.get(`${API_URL}/active`);
    return res.data;
};

export const createSms = async (data) => {
    const res = await axios.post(API_URL, data);
    return res.data;
};

export const updateSms = async (id, data) => {
    const res = await axios.put(`${API_URL}/${id}`, data);
    return res.data;
};

export const deleteSms = async (id) => {
    await axios.delete(`${API_URL}/${id}`);
};

export const resetForm = () => ({
    companyName: "",
    username: "",
    password: "",
    smsUrl: "",
    active: true,
});